import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SEO from "@/components/seo/SEO";
import { Eyebrow, SectionHeading } from "@/components/common/ui";
import { Bed, Sparkle, ForkKnife, Robot, ChartLineUp } from "@phosphor-icons/react";

const ICONS = { reception: Bed, housekeeping: Sparkle, restaurant: ForkKnife, "ai-copilot": Robot, analytics: ChartLineUp };

export default function ModulesIndex() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || "en";
  const modules = t("modules.list", { returnObjects: true }) || [];

  return (
    <>
      <SEO title={lang === "nl" ? "Modules — BHT One" : "Modules — BHT One"} path="/modules" />
      <section className="relative py-32 lg:py-44">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
          <Eyebrow>{t("modules.eyebrow")}</Eyebrow>
          <SectionHeading title={t("modules.h1")} sub={t("modules.sub")} className="mt-4" />
          <div className="mt-16 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
            {modules.map((m, i) => {
              const Icon = ICONS[m.slug] || Bed;
              return (
                <Link
                  key={m.slug}
                  to={`/${lang}/modules/${m.slug}`}
                  className="group flex flex-col rounded-2xl border border-white/[0.06] bg-white/[0.02] p-8 transition-colors hover:border-bht-gold/30"
                  data-testid={`modules-index-${m.slug}`}
                >
                  <div className="flex items-center justify-between">
                    <Icon size={26} weight="thin" className="text-bht-gold" />
                    <span className="font-mono text-[10px] uppercase tracking-widest text-white/30">M/{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <div className="mt-8 font-serif text-2xl group-hover:text-bht-gold">{m.title}</div>
                  <p className="mt-3 text-sm text-white/55">{m.desc}</p>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
